// Rótulos e utilidades da planilha de contestações.
// Regra do dono: só é "Perdemos" quando o dinheiro voltou pro comprador.
export const STATUS = {
  open: { label: 'Aberta', cls: 'bg-red-600 text-white' },
  closed_won: { label: 'Ganhamos', cls: 'bg-emerald-600 text-white' },
  closed_lost: { label: 'Perdemos', cls: 'bg-rose-800 text-white' },
  closed: { label: 'Verificar', cls: 'bg-amber-600 text-white' },
};

export const GATEWAY = { mercadopago: 'Mercado Pago', stripe: 'Stripe', efi: 'EFI (Pix)' };
export const KIND = { claim: 'Reclamação', chargeback: 'Chargeback', dispute: 'Disputa',
  med: 'MED' };

export const FILTROS = [
  { id: 'all', label: 'Todas', status: null },
  { id: 'open', label: 'Abertas', status: 'open' },
  { id: 'closed_won', label: 'Ganhamos', status: 'closed_won' },
  { id: 'closed_lost', label: 'Perdemos', status: 'closed_lost' },
  { id: 'closed', label: 'Verificar', status: 'closed' },
];

export const fmtData = (iso) => (iso ? new Date(iso).toLocaleString('pt-BR') : '-');
export const fmtDia = (iso) => (iso ? new Date(iso).toLocaleDateString('pt-BR') : '-');
const sinal = (m) => (m === 'EUR' ? '€' : m === 'USD' ? '$' : 'R$');
export const fmtMoeda = (v, m) => (v == null || v === ''
  ? '-'
  : `${sinal(m)} ${Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`);

export const dataPix = (d) => d.transaction_at || d.opened_at;
export const nomeCliente = (d) => d.customer_name || d.payer_name || '-';
export const docCliente = (d) => d.document || d.payer_document || '-';

export const filtrar = (lista, { resultado, gateway, busca }) => {
  const texto = (busca || '').trim().toLowerCase();
  return lista.filter((d) => {
    if (resultado !== 'all' && d.status !== resultado) return false;
    if (gateway !== 'all' && d.gateway !== gateway) return false;
    if (!texto) return true;
    return [nomeCliente(d), docCliente(d), d.kako_id, d.kako_nickname, d.order_id,
      d.protocol, d.external_id, d.reason, d.whatsapp_tail]
      .some((v) => String(v || '').toLowerCase().includes(texto));
  });
};

export const somarPorMoeda = (lista) => lista.reduce((acc, d) => {
  const m = d.currency || 'BRL';
  acc[m] = (acc[m] || 0) + Number(d.amount || 0);
  return acc;
}, {});

export const totaisTexto = (lista) => Object.entries(somarPorMoeda(lista))
  .map(([m, v]) => fmtMoeda(v, m)).join(' + ') || '-';

const COLUNAS = [
  ['Data do Pix', (d) => fmtData(dataPix(d))],
  ['Aberta em', (d) => fmtData(d.opened_at)],
  ['Encerrada em', (d) => fmtData(d.closed_at_gateway || d.closed_at)],
  ['Gateway', (d) => GATEWAY[d.gateway] || d.gateway],
  ['Tipo', (d) => KIND[d.kind] || d.kind],
  ['Resultado', (d) => STATUS[d.status]?.label || d.status],
  ['Desfecho', (d) => d.result_note || d.resolution || ''],
  ['Cliente', (d) => nomeCliente(d)],
  ['Apelido KAKO', (d) => d.kako_nickname || ''],
  ['KAKO ID', (d) => d.kako_id || ''],
  ['Documento', (d) => docCliente(d)],
  ['WhatsApp', (d) => (d.whatsapp_tail ? `...${d.whatsapp_tail}` : '')],
  ['Valor', (d) => String(Number(d.amount || 0).toFixed(2)).replace('.', ',')],
  ['Moeda', (d) => d.currency || 'BRL'],
  ['Motivo', (d) => d.reason || ''],
  ['Alegação do cliente', (d) => d.claim_text || ''],
  ['Pedido', (d) => d.order_id || 'não localizado'],
  ['Cliente bloqueado', (d) => (d.blocked_now ? 'sim' : 'não')],
  ['Protocolo', (d) => d.protocol || ''],
  ['Ticket', (d) => (d.ticket || []).join(' / ')],
  ['ID no gateway', (d) => d.external_id || ''],
  ['txid', (d) => d.txid || ''],
  ['EndToEndId', (d) => d.e2e_id || ''],
];

export const baixarCSV = (lista) => {
  const esc = (v) => `"${String(v ?? '').replace(/"/g, '""').replace(/\r?\n/g, ' ')}"`;
  const linhas = [COLUNAS.map(([t]) => esc(t)).join(';')];
  lista.forEach((d) => linhas.push(COLUNAS.map(([, fn]) => esc(fn(d))).join(';')));
  const blob = new Blob([`\ufeff${linhas.join('\r\n')}`], { type: 'text/csv;charset=utf-8;' });
  const a = document.createElement('a');
  a.href = URL.createObjectURL(blob);
  a.download = `contestacoes-${new Date().toISOString().slice(0, 10)}.csv`;
  a.click();
  URL.revokeObjectURL(a.href);
};
